import {StateCreator} from 'zustand'
import {TProtectionZone} from '../types/protectionZone.types'

type State = {
  protectionZones: (TProtectionZone | null)[]
}
type Action = {
  setProtectionZones: (protectionZones: (TProtectionZone | null)[]) => void
}

export type ProtectionZoneSlice = State & Action

const createProtectionZoneSlice: StateCreator<ProtectionZoneSlice> = set => ({
  protectionZones: [],
  setProtectionZones: protectionZones =>
    set({protectionZones: protectionZones}),
})

export default createProtectionZoneSlice
